export const ADMIN_ROLES = ['accountant', 'administrator'];

export function hasPermission(userPermissions, permission) {
  if (!permission) return true;
  if (!userPermissions?.length) return false;
  return userPermissions.includes(permission);
}

export function hasAnyPermission(userPermissions, required) {
  if (!required?.length) return true;
  return required.some((p) => userPermissions.includes(p));
}

export function canAccessAdmin(userPermissions, isAdmin, roleId) {
  if (roleId === 'customer') return false;
  return isAdmin && userPermissions?.length > 0;
}

export const MENU_PERMISSIONS = {
  brands: 'brands:read',
  category: 'categories:read',
  types: 'types:read',
  models: 'models:read',
  items: 'items:read',
  carousel: 'carousel:read',
  orders: 'orders:read',
  delivery: 'delivery:read',
  users: 'users:read',
};


export const ROLE_LABELS = {
  customer: 'Customer',
  accountant: 'Accountant',
  administrator: 'Administrator',
};



export const ADMIN_PAGE_PERMISSIONS = [
  {
    path: "/admin/orders",
    permission: "orders:read",
  },
  {
    path: "/admin/delivery",
    permission: "delivery:read",
  },
  {
    path: "/admin/brands",
    permission: "brands:read",
  },
  {
    path: "/admin/category",
    permission: "categories:read",
  },
  {
    path: "/admin/types",
    permission: "types:read",
  },
  {
    path: "/admin/models",
    permission: "models:read",
  },
  {
    path: "/admin/items",
    permission: "items:read",
  },
  {
    path: "/admin/carousel",
    permission: "carousel:read",
  },
  {
    path: "/admin/users",
    permission: "users:read",
  },
];


export function getFirstAllowedAdminPage(permissions) {
  return (
    ADMIN_PAGE_PERMISSIONS.find((page) =>
      hasPermission(permissions, page.permission)
    )?.path || "/"
  );
}